import { css } from "@emotion/core";

export const DepartmentStyles = css({});
